export function DailyReportCardSkeleton() {
  return (
    <div className="animate-pulse break-inside-avoid overflow-hidden rounded-md relative">
      <div className="flex flex-col w-full bg-gray-300 rounded">
        <header className="flex justify-between">
          <div className="flex flex-col p-4">
            <div className="flex">
              <div
                className="w-6 h-6 md:w-8 md:h-8 object-cover rounded-md border bg-slate-400"
              />
              <div className="ml-4 bg-slate-400 h-6 w-[200px] rounded-md" />
            </div>
            <div
              className="bg-slate-400 rounded-md font-semibold mt-4 h-4 w-[200px]"
            />
          </div>
          <div className="flex">
            <div
              className="w-[100px] h-6 object-cover rounded-md border bg-slate-400 mt-4"
            />
            <div
              className="bg-slate-500 flex items-center justify-center px-4 ml-4 rounded-sm transition-colors min-w-[57px] text-center disabled:opacity-50"
            />
          </div>
        </header>
      </div>
    </div>
  )
}
